(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-contact-message]').forEach((textarea) => {
      if (textarea.dataset.counterReady) return;
      textarea.dataset.counterReady = 'true';
      const count = textarea.parentElement.querySelector('[data-contact-count]');
      const update = () => { if (count) count.textContent = textarea.value.length; };
      textarea.addEventListener('input', update);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
